export default "__VITE_ASSET__OkGQClNx__"